// src/redux/slices/certificateSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from '../../../utils/apiPath';

export const loadCertificates = createAsyncThunk(
  "certificate/loadCertificates",
  async (request, { rejectWithValue }) => {
    try {
      const response = await agent.get(API.LOAD_CERTIFICATE, {
        params: request,
      });

      return {
        data: response.data?.data?.data || [],
        pagination: response.data?.data?.pagination || {
          total: 0,
          count: 0,
          per_page: 10,
          current_page: 1,
          total_pages: 1,
        },
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to load certificates"
      );
    }
  }
);

const certificateSlice = createSlice({
  name: "certificate",
  initialState: {
    certificateData: [],
    pagination: {
      total: 0,
      count: 0,
      per_page: 10,
      current_page: 1,
      total_pages: 1,
    },
    loading: false,
    error: null,
  },
  reducers: {
    clearCertificates: (state) => {
      state.certificateData = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadCertificates.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadCertificates.fulfilled, (state, action) => {
        state.loading = false;
        state.certificateData = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(loadCertificates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCertificates } = certificateSlice.actions;
export default certificateSlice.reducer;
